import React, { Component } from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import createBreakpoints from '@material-ui/core/styles/createBreakpoints';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';

import { themes } from './constants/styles';

import Router from './Router/Router';
import FeedbackBar from './components/FeedbackBar/FeedbackBar';

import { company } from './utils/brand';

function pxToRem(value) {
  return `${value / 16}rem`;
}

const breakpoints = createBreakpoints({});
export const theme = createMuiTheme({
  ...themes[company],
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 1024,
      lg: 1280,
      xl: 1920,
    },
  },
  transitions: {
    create: () => 'none',
  },
  typography: {
    headline: {
      fontSize: pxToRem(24),
      [breakpoints.up('sm')]: {
        fontSize: pxToRem(32)
      }
    },
    title: {
      fontSize: pxToRem(21),
      [breakpoints.up('sm')]: {
        fontSize: pxToRem(24)
      }
    },
    body1: {
      fontSize: pxToRem(14),
      [breakpoints.up('sm')]: {
        fontSize: pxToRem(16)
      }
    },
    body2: {
      fontSize: pxToRem(12),
      [breakpoints.up('sm')]: {
        fontSize: pxToRem(14)
      }
    },
    button: {
      fontSize: pxToRem(14),
      [breakpoints.up('sm')]: {
        fontSize: pxToRem(16)
      }
    },
    caption: {
      fontSize: pxToRem(11),
      [breakpoints.up('sm')]: {
        fontSize: pxToRem(12)
      }
    },
  },
});

class App extends Component {
  render() {
    return (
      <MuiThemeProvider theme={theme}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <CssBaseline />
          <FeedbackBar />
          <Router />
        </MuiPickersUtilsProvider>
      </MuiThemeProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js